import styled from 'styled-components';
import { Heading, IconNotificationSuccess } from '@snsw-gel/react';

export const ConfirmationHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 2rem 0 0.75rem;
`;

export const StyledTickIcon = styled(IconNotificationSuccess)`
  width: 2rem;
  height: 2rem;
`;

export const StyledHeading = styled(Heading)`
  && {
    margin: 0;
    padding: 0;
    line-height: 1.2;
  }
`;

export const NotificationText = styled.div`
  line-height: 1.5;
`;

export const EventCardWrapper = styled.div`
  max-width: 370px;
  margin-top: 1rem;
`;

export const ManageText = styled.p`
  margin-top: 2rem;
`;

export const TutdWidget = styled.div`
  margin: 3em auto 0em auto;
  max-width: 38rem;
`;

export const EventDetailsBody = styled.p`
  display: flex;
  gap: 12px;
`;

export const EventTypeLabel = styled.p`
  font-weight: bold;
`;
